/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PinataSDK } from "pinata";

const PINATA_SECRET_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiJlZGE3OTU1ZS01NThhLTQ0YjItYmUwYS0xMmE5NTRhYmYxZGMiLCJlbWFpbCI6InJvaW92ZXJAcHJvdG9uLm1lIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInBpbl9wb2xpY3kiOnsicmVnaW9ucyI6W3siZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiRlJBMSJ9LHsiZGVzaXJlZFJlcGxpY2F0aW9uQ291bnQiOjEsImlkIjoiTllDMSJ9XSwidmVyc2lvbiI6MX0sIm1mYV9lbmFibGVkIjpmYWxzZSwic3RhdHVzIjoiQUNUSVZFIn0sImF1dGhlbnRpY2F0aW9uVHlwZSI6InNjb3BlZEtleSIsInNjb3BlZEtleUtleSI6ImIxYWRiNjVmMjdmZWNhMmIxY2RjIiwic2NvcGVkS2V5U2VjcmV0IjoiNmUzY2RjNmExNWU1YThhNWUxNTkwMmI5NGUwMWM1MjgyY2U0ODM3ODBhMWY0ZjcwMzQxYzI3NTFjYjVhNTlkZCIsImV4cCI6MTc2NDQxMjU3Nn0.FD15exn56ICeP46SOWpCXkOqpgsR1Evh9Cde9-xnUjI';  // Replace with your Infura Project Secret
const pinata = new PinataSDK({
  pinataJwt: PINATA_SECRET_API_KEY,
  pinataGateway: "https://magenta-able-dormouse-779.mypinata.cloud",
});
const GalleryPage = () => {
  const { bunkerId } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const jsonUrl = params.get('x');
  const [imageUrls, setImageUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [descrx, setDescrx] = useState([]);
  const [Noticex, setNoticex] = useState([]);
  const [filesDeleted, setFilesDeleted] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  function extractAfterFiles(url) {
    return url.split('files/')[1];
  }

  const deleteFilesWithDelay = async (ids, delay) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, delay));
      await pinata.files.delete(ids);
    } catch (error) {
      console.error("Error deleting files:", error);
    }
  };

  const handleImageError = (event) => {
    const img = event.target;
    setTimeout(() => {
      if (!img.complete || img.naturalWidth === 0) {
        setFilesDeleted(true);
      }
    }, 3000);
  };

   useEffect(() => {
      const body = document.body;

      const closeAllSelect = (elmnt) => {
      document.querySelectorAll('.select-selected').forEach((select) => {
        if (elmnt !== select) {
          select.classList.remove('select-arrow-active');
        }
      });

      document.querySelectorAll('.select-items').forEach((items) => {
        items.classList.add('select-hide');
      });
    };

        const handleDropdowns = () => {
      document.querySelectorAll('.custom-select').forEach((customSelect) => {
        const selectSelected = customSelect.querySelector('.select-selected');
        const selectItems = customSelect.querySelector('.select-items');
        const selectItemsList = customSelect.querySelector('.select-items-list');
        const hiddenInput = customSelect.querySelector('input[type="hidden"]');

        if (!selectSelected || !selectItems || !selectItemsList || !hiddenInput) return;

        selectSelected.addEventListener('click', function (e) {
          e.stopPropagation();
          closeAllSelect(this);
          this.classList.toggle('select-arrow-active');
          selectItems.classList.toggle('select-hide');
        });

        selectItemsList.querySelectorAll('div').forEach((item) => {
          item.addEventListener('click', function () {
            const selectedValue = this.getAttribute('data-value');
            const selectedText = this.textContent;

            selectSelected.textContent = selectedText;
            hiddenInput.value = selectedValue;

            selectItemsList.querySelectorAll('.same-as-selected').forEach((el) => {
              el.classList.remove('same-as-selected');
            });

            this.classList.add('same-as-selected');
            selectSelected.click();
          });
        });

        // Initialize with first option
        const firstItem = selectItemsList.querySelector('div');
        if (firstItem) {
          const defaultValue = firstItem.getAttribute('data-value');
          const defaultText = firstItem.textContent;
          selectSelected.textContent = defaultText;
          hiddenInput.value = defaultValue;
          firstItem.classList.add('same-as-selected');
        }
      });
    };

    const handleModals = () => {
      document.querySelectorAll('[data-modal]').forEach((button) => {
        button.addEventListener('click', () => {
          const modalId = button.getAttribute('data-modal');
          const modal = document.getElementById(modalId);
          const imgSrc = button.getAttribute('data-img');
          const img = modal?.querySelector('.modal-body-img img');

          if (img && imgSrc) img.src = imgSrc;

          modal?.classList.add('active');
          body.style.overflow = 'hidden';
        });
      });

      document.querySelectorAll('.close').forEach((button) => {
        button.addEventListener('click', () => {
          const modalId = button.getAttribute('data-modal-close');
          const modal = document.getElementById(modalId);
          modal?.classList.remove('active');
          body.style.overflow = 'auto';
        });
      });

      document.querySelectorAll('.modal').forEach((modal) => {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            modal.classList.remove('active');
            body.style.overflow = 'auto';
          }
        });
      });
    };

    const handleDocumentClick = () => {
      document.addEventListener('click', closeAllSelect);
    };

    const fetchData = async () => {
      try {
        const urlx = await pinata.gateways.createSignedURL({
          cid: bunkerId,
          expires: 3000,
        });
       // const proxyUrl = `https://cc-production-c6e6.up.railway.app/proxy?url=${encodeURIComponent(urlx)}`;

        const proxyUrl = `https://photobunker.pro/proxy?url=${encodeURIComponent(urlx)}`;
        console.log(proxyUrl);

        const response = await fetch(proxyUrl);
        console.log('response');

 console.log(response);
        if (!response.ok) throw new Error('Галлерея будет доступна в ближайшее время');
        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Галлерея будет доступна в ближайшее время или неверный формат");
        }

        const data = await response.json();
        console.log(data);

        const imageUrls = await Promise.all(
          data.images.map(async (image) => {
            const cid = extractAfterFiles(image.url);
            const url = await pinata.gateways.createSignedURL({
              cid: cid,
              expires: 3000,
            });
            return url;
          })
        );
        console.log(imageUrls);

        setImageUrls(imageUrls);

        if (data.timex === 1 && data.xec) {
          const idsToDelete = data.xec.map((entry) => entry.id);
          setNoticex(data.timex);
          await deleteFilesWithDelay(idsToDelete, 4000);
        }

        setDescrx(data.description);
      } catch (error) {
        console.error(error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    handleDropdowns();
    handleModals();
    handleDocumentClick();
  }, [jsonUrl]);


if (filesDeleted) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-red-500 to-red-800 text-white py-4 px-8 rounded-lg shadow-lg mb-6">
          Файлы были удалены и больше недоступны.
        </h1>
        <button
          onClick={() => (window.location.href = "/")}
          className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-purple-500 hover:to-blue-500 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300"
        >
          Вернуться на главную страницу
        </button>
      </div>
    );
  }

  if (error) {
    return <div className="text-center text-red-500">Error: {error}</div>;
  }
  const Loader = () => (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white">
      <div className="flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-lg shadow-lg">
        <span className="text-2xl font-semibold">X</span>
        <div className="flex space-x-1">
          <span className="w-2 h-2 bg-white rounded-full animate-bounce"></span>
          <span className="w-2 h-2 bg-white rounded-full animate-bounce"></span>
          <span className="w-2 h-2 bg-white rounded-full animate-bounce"></span>
        </div>
      </div>
      <p className="mt-4 text-sm">Загрузка... Ожидайте</p>
    </div>
  );  
  return (
    <div>
 <header>
  <div className="logo">
   <svg fill="none" height="42" viewbox="0 0 115 42" width="115">
    <path d="M94.9447 20.0833C93.6603 20.0833 92.5116 19.805 91.4985 19.2483C90.4854 18.6916 89.6894 17.9014 89.1105 16.8777C88.5316 15.8361 88.2422 14.606 88.2422 13.1873C88.2422 11.7506 88.5316 10.5114 89.1105 9.46984C89.7075 8.42825 90.5125 7.62909 91.5256 7.07238C92.5568 6.51566 93.7146 6.2373 94.999 6.2373C96.2834 6.2373 97.4322 6.51566 98.4452 7.07238C99.4764 7.62909 100.281 8.42825 100.86 9.46984C101.457 10.4935 101.756 11.7147 101.756 13.1334C101.756 14.5701 101.457 15.8092 100.86 16.8508C100.263 17.8924 99.4493 18.6916 98.4181 19.2483C97.387 19.805 96.2292 20.0833 94.9447 20.0833ZM94.9176 18.1708C95.7136 18.1708 96.4643 18.0002 97.1699 17.6589C97.8754 17.2998 98.4452 16.752 98.8794 16.0157C99.3317 15.2615 99.5578 14.3097 99.5578 13.1603C99.5578 11.993 99.3407 11.0412 98.9066 10.3049C98.4724 9.56862 97.9025 9.02986 97.197 8.68865C96.5096 8.32948 95.7678 8.14989 94.9719 8.14989C94.1759 8.14989 93.4342 8.32948 92.7467 8.68865C92.0593 9.02986 91.4985 9.57759 91.0643 10.3319C90.6482 11.0682 90.4402 12.011 90.4402 13.1603C90.4402 14.3276 90.6482 15.2794 91.0643 16.0157C91.4804 16.752 92.0231 17.2998 92.6925 17.6589C93.3799 18.0002 94.1216 18.1708 94.9176 18.1708Z" fill="#F5F4F3">
    </path>
    <path d="M81.7696 6.42657V2.65527H83.8047V6.42657H87.4138V8.31222H83.8047V15.5585C83.8047 16.3846 83.9766 16.9862 84.3203 17.3633C84.6821 17.7405 85.1344 17.9649 85.6771 18.0368C86.2379 18.1086 86.8168 18.1086 87.4138 18.0368V19.7877C86.7083 19.9494 86.0118 19.9943 85.3243 19.9224C84.655 19.8506 84.049 19.653 83.5063 19.3298C82.9816 18.9886 82.5565 18.5127 82.2309 17.9021C81.9233 17.2915 81.7696 16.5103 81.7696 15.5585V8.31222H79.7344V6.42657H81.7696Z" fill="#F5F4F3">
    </path>
    <path d="M72.1127 20.0833C70.8283 20.0833 69.6795 19.805 68.6665 19.2483C67.6534 18.6916 66.8574 17.9014 66.2785 16.8777C65.6996 15.8361 65.4102 14.606 65.4102 13.1873C65.4102 11.7506 65.6996 10.5114 66.2785 9.46984C66.8755 8.42825 67.6805 7.62909 68.6936 7.07238C69.7247 6.51566 70.8825 6.2373 72.167 6.2373C73.4514 6.2373 74.6001 6.51566 75.6132 7.07238C76.6444 7.62909 77.4494 8.42825 78.0283 9.46984C78.6253 10.4935 78.9238 11.7147 78.9238 13.1334C78.9238 14.5701 78.6253 15.8092 78.0283 16.8508C77.4313 17.8924 76.6172 18.6916 75.5861 19.2483C74.5549 19.805 73.3971 20.0833 72.1127 20.0833ZM72.0856 18.1708C72.8815 18.1708 73.6323 18.0002 74.3378 17.6589C75.0434 17.2998 75.6132 16.752 76.0474 16.0157C76.4997 15.2615 76.7258 14.3097 76.7258 13.1603C76.7258 11.993 76.5087 11.0412 76.0745 10.3049C75.6404 9.56862 75.0705 9.02986 74.365 8.68865C73.6775 8.32948 72.9358 8.14989 72.1398 8.14989C71.3438 8.14989 70.6021 8.32948 69.9147 8.68865C69.2273 9.02986 68.6665 9.57759 68.2323 10.3319C67.8162 11.0682 67.6082 12.011 67.6082 13.1603C67.6082 14.3276 67.8162 15.2794 68.2323 16.0157C68.6484 16.752 69.1911 17.2998 69.8604 17.6589C70.5479 18.0002 71.2896 18.1708 72.0856 18.1708Z" fill="#F5F4F3">
    </path>
    <path d="M52.2148 0.5H54.25V8.25809C54.6842 7.61158 55.2721 7.11772 56.0139 6.77651C56.7556 6.41734 57.5877 6.23776 58.5103 6.23776C59.5053 6.23776 60.3918 6.46224 61.1697 6.9112C61.9475 7.36017 62.5536 8.02463 62.9878 8.9046C63.44 9.78457 63.6662 10.88 63.6662 12.191V19.8952H61.4953V12.4335C61.4953 11.0327 61.1968 9.96415 60.5998 9.22785C60.0028 8.47359 59.1345 8.09647 57.9948 8.09647C56.8189 8.09647 55.8963 8.49155 55.2269 9.28173C54.5757 10.0719 54.25 11.2213 54.25 12.7298V19.8952H52.2148V0.5Z" fill="#F5F4F3">
    </path>
    <path d="M43.8744 10.3057C44.8875 10.3057 45.7106 10.153 46.3438 9.84773C46.9769 9.54244 47.4383 9.11143 47.7277 8.55471C48.0352 7.998 48.189 7.35149 48.189 6.61519C48.189 5.44789 47.8453 4.54098 47.1578 3.89447C46.4885 3.24796 45.394 2.92471 43.8744 2.92471H39.3427V10.3057H43.8744ZM50.3327 6.61519C50.3327 7.35149 50.2061 8.06086 49.9528 8.74328C49.7177 9.40775 49.3378 10.0004 48.8131 10.5212C48.2885 11.042 47.6192 11.455 46.8051 11.7603C45.991 12.0477 45.0141 12.1913 43.8744 12.1913H39.3427V19.8955H37.1719V1.03906H43.8744C45.3578 1.03906 46.5699 1.29048 47.5106 1.79332C48.4694 2.29616 49.1749 2.96961 49.6272 3.81366C50.0976 4.65771 50.3327 5.59155 50.3327 6.61519Z" fill="#F5F4F3">
    </path>
    <path d="M108 27.8419H109.872L109.981 29.8084C110.343 29.3235 110.777 28.9104 111.283 28.5692C111.808 28.228 112.378 27.9946 112.993 27.8688C113.626 27.7252 114.295 27.7162 115.001 27.8419V29.8622C114.241 29.7186 113.554 29.7186 112.939 29.8622C112.342 30.0059 111.826 30.2753 111.392 30.6704C110.958 31.0655 110.623 31.5683 110.388 32.1789C110.153 32.7715 110.035 33.4629 110.035 34.2531V41.3108H108V27.8419Z" fill="#F5F4F3">
    </path>
    <path d="M99.7389 41.4994C98.4726 41.4994 97.3419 41.1941 96.347 40.5835C95.3701 39.9729 94.6012 39.1378 94.0404 38.0783C93.4796 37.0187 93.1992 35.8065 93.1992 34.4417C93.1992 33.1307 93.4796 31.9634 94.0404 30.9397C94.6012 29.9161 95.3701 29.1169 96.347 28.5423C97.3239 27.9496 98.4364 27.6533 99.6847 27.6533C100.915 27.6533 102.009 27.9227 102.968 28.4615C103.945 29.0002 104.705 29.7455 105.248 30.6973C105.79 31.6491 106.043 32.7356 106.007 33.9568C106.007 34.1543 105.998 34.3608 105.98 34.5763C105.962 34.7918 105.944 35.0253 105.926 35.2767H95.4244C95.4605 36.1208 95.6686 36.8661 96.0485 37.5126C96.4284 38.1591 96.9259 38.6709 97.5409 39.048C98.1741 39.4072 98.8887 39.5868 99.6847 39.5868C100.734 39.5868 101.62 39.3892 102.344 38.9941C103.086 38.5991 103.619 38.0334 103.945 37.2971L105.709 37.9974C105.166 39.1288 104.379 39.9998 103.348 40.6104C102.317 41.203 101.114 41.4994 99.7389 41.4994ZM103.782 33.5258C103.8 32.7535 103.628 32.0711 103.267 31.4785C102.923 30.8859 102.434 30.4189 101.801 30.0777C101.168 29.7365 100.435 29.5659 99.6033 29.5659C98.8796 29.5659 98.2193 29.7365 97.6224 30.0777C97.0254 30.4189 96.5279 30.8948 96.1299 31.5054C95.75 32.0981 95.5239 32.7715 95.4515 33.5258H103.782Z" fill="#F5F4F3">
    </path>
    <path d="M81.3555 21.916H83.4178V33.6878H84.666L90.0118 27.8423H92.8882L86.4841 34.5768L92.9153 41.3112H90.0118L84.666 35.4388H83.4178V41.3112H81.3555V21.916Z" fill="#F5F4F3">
    </path>
    <path d="M67.4219 27.8419H69.2942L69.4028 29.7545C69.837 29.09 70.4068 28.5782 71.1123 28.219C71.8179 27.8419 72.641 27.6533 73.5817 27.6533C74.6129 27.6533 75.5174 27.8778 76.2953 28.3268C77.0732 28.7578 77.6792 29.4133 78.1134 30.2932C78.5476 31.1552 78.7646 32.2417 78.7646 33.5527V41.3108H76.7295V33.7951C76.7295 32.3944 76.4219 31.3348 75.8068 30.6165C75.2098 29.8802 74.3415 29.512 73.2018 29.512C72.0259 29.512 71.1033 29.8981 70.4339 30.6704C69.7827 31.4426 69.4571 32.5829 69.4571 34.0915V41.3108H67.4219V27.8419Z" fill="#F5F4F3">
    </path>
    <path d="M64.6359 41.3107H62.7907L62.655 39.3712C62.2389 40.0536 61.6781 40.5834 60.9726 40.9605C60.2671 41.3197 59.444 41.4993 58.5032 41.4993C57.454 41.4993 56.5404 41.2838 55.7625 40.8528C54.9846 40.4218 54.3786 39.7753 53.9444 38.9132C53.5284 38.0512 53.3203 36.9647 53.3203 35.6538V27.8418H55.3284V35.4383C55.3284 36.8211 55.6269 37.8716 56.2238 38.59C56.8389 39.2904 57.7163 39.6406 58.856 39.6406C60.0138 39.6406 60.9274 39.2724 61.5967 38.5361C62.2842 37.7819 62.6279 36.6505 62.6279 35.1419V27.8418H64.6359V41.3107Z" fill="#F5F4F3">
    </path>
    <path d="M48.6777 27.5733C48.6777 26.5855 48.343 25.8043 47.6736 25.2297C47.0224 24.637 46.0455 24.3407 44.743 24.3407H39.3701V30.7789H44.8244C46.0545 30.7789 47.0043 30.4915 47.6736 29.9169C48.343 29.3422 48.6777 28.561 48.6777 27.5733ZM37.1992 41.3116V22.4551H44.9329C46.2716 22.4551 47.3751 22.6796 48.2435 23.1285C49.1118 23.5775 49.754 24.1701 50.1701 24.9064C50.6043 25.6248 50.8214 26.4239 50.8214 27.3039C50.8214 28.1659 50.6586 28.8932 50.3329 29.4859C50.0254 30.0605 49.6003 30.5185 49.0576 30.8597C48.5329 31.2009 47.954 31.4344 47.3209 31.5601V31.7486C48.0807 31.8564 48.7591 32.0988 49.3561 32.4759C49.953 32.8351 50.4234 33.329 50.7671 33.9575C51.1108 34.5861 51.2827 35.3493 51.2827 36.2472C51.2827 37.1811 51.0475 38.0341 50.5772 38.8063C50.1068 39.5786 49.4103 40.1891 48.4877 40.6381C47.5832 41.0871 46.4706 41.3116 45.15 41.3116H37.1992ZM39.3701 39.4259H44.9872C46.2897 39.4259 47.3028 39.1386 48.0264 38.5639C48.7681 37.9713 49.139 37.1272 49.139 36.0317C49.139 34.9363 48.75 34.1012 47.9721 33.5265C47.2123 32.9518 46.1902 32.6645 44.9058 32.6645H39.3701V39.4259Z" fill="#F5F4F3">
    </path>
    <path d="M11.1552 16.592H2.2405L2.24092 28.6272L12.5543 35.5039L21.9095 28.6528L21.9093 7.37963L12.0985 10.8881L4.85008 8.67972L4.83687 8.67562L4.82385 8.67132L0 7.04297L0.592345 5.31376L5.40339 6.93759L12.0518 8.96307L23.7494 4.78027L23.7496 29.5753L12.6043 37.7373L0.401093 29.6009L0.400267 14.7654H12.9952V27.1604H11.1552V16.592Z" fill="#C4ED31">
    </path>
   </svg>
  </div>
  <button className="btn btn-primary btn-icon active">
   <svg fill="none" height="18" viewbox="0 0 18 18" width="18">
    <path clip-rule="evenodd" d="M1.6875 5.25C1.6875 4.93934 1.93934 4.6875 2.25 4.6875H15.75C16.0607 4.6875 16.3125 4.93934 16.3125 5.25C16.3125 5.56066 16.0607 5.8125 15.75 5.8125H2.25C1.93934 5.8125 1.6875 5.56066 1.6875 5.25Z" fill="#21252A" fill-rule="evenodd">
    </path>
    <path clip-rule="evenodd" d="M1.6875 9C1.6875 8.68934 1.93934 8.4375 2.25 8.4375H15.75C16.0607 8.4375 16.3125 8.68934 16.3125 9C16.3125 9.31066 16.0607 9.5625 15.75 9.5625H2.25C1.93934 9.5625 1.6875 9.31066 1.6875 9Z" fill="#21252A" fill-rule="evenodd">
    </path>
    <path clip-rule="evenodd" d="M1.6875 12.75C1.6875 12.4393 1.93934 12.1875 2.25 12.1875H15.75C16.0607 12.1875 16.3125 12.4393 16.3125 12.75C16.3125 13.0607 16.0607 13.3125 15.75 13.3125H2.25C1.93934 13.3125 1.6875 13.0607 1.6875 12.75Z" fill="#21252A" fill-rule="evenodd">
    </path>
   </svg>
  </button>
 </header>
 <main>
  <aside>
   <div className="aside-content">
    <div className="logo">
     <svg fill="none" height="83" viewbox="0 0 230 83" width="230">
      <path d="M189.873 39.4518C187.304 39.4518 185.007 38.8911 182.981 37.7695C180.955 36.648 179.363 35.0562 178.205 32.9941C177.048 30.8958 176.469 28.4176 176.469 25.5596C176.469 22.6653 177.048 20.1691 178.205 18.0708C179.399 15.9725 181.009 14.3626 183.035 13.241C185.097 12.1195 187.413 11.5588 189.981 11.5588C192.55 11.5588 194.847 12.1195 196.873 13.241C198.935 14.3626 200.545 15.9725 201.703 18.0708C202.897 20.1329 203.494 22.593 203.494 25.451C203.494 28.3452 202.897 30.8415 201.703 32.9398C200.509 35.0381 198.881 36.648 196.819 37.7695C194.757 38.8911 192.441 39.4518 189.873 39.4518ZM189.818 35.5989C191.41 35.5989 192.912 35.2552 194.322 34.5678C195.733 33.8443 196.873 32.7408 197.741 31.2576C198.646 29.7381 199.098 27.8207 199.098 25.5053C199.098 23.1537 198.664 21.2363 197.796 19.753C196.927 18.2697 195.788 17.1844 194.377 16.497C193.002 15.7735 191.519 15.4117 189.927 15.4117C188.335 15.4117 186.852 15.7735 185.477 16.497C184.102 17.1844 182.981 18.2878 182.112 19.8073C181.28 21.2906 180.864 23.1899 180.864 25.5053C180.864 27.8568 181.28 29.7743 182.112 31.2576C182.945 32.7408 184.03 33.8443 185.368 34.5678C186.743 35.2552 188.227 35.5989 189.818 35.5989Z" fill="#F5F4F3">
      </path>
      <path d="M163.525 11.9388V4.34143H167.595V11.9388H174.813V15.7374H167.595V30.3351C167.595 31.9993 167.939 33.2113 168.626 33.971C169.35 34.7307 170.254 35.1829 171.339 35.3277C172.461 35.4724 173.619 35.4724 174.813 35.3277V38.855C173.402 39.1806 172.009 39.271 170.634 39.1263C169.295 38.9816 168.083 38.5837 166.998 37.9325C165.949 37.2451 165.099 36.2864 164.448 35.0563C163.833 33.8263 163.525 32.2526 163.525 30.3351V15.7374H159.455V11.9388H163.525Z" fill="#F5F4F3">
      </path>
      <path d="M144.214 39.4518C141.646 39.4518 139.348 38.8911 137.323 37.7695C135.297 36.648 133.705 35.0562 132.547 32.9941C131.389 30.8958 130.811 28.4176 130.811 25.5596C130.811 22.6653 131.389 20.1691 132.547 18.0708C133.741 15.9725 135.351 14.3626 137.377 13.241C139.439 12.1195 141.754 11.5588 144.323 11.5588C146.892 11.5588 149.189 12.1195 151.215 13.241C153.277 14.3626 154.887 15.9725 156.045 18.0708C157.238 20.1329 157.835 22.593 157.835 25.451C157.835 28.3452 157.238 30.8415 156.045 32.9398C154.851 35.0381 153.223 36.648 151.161 37.7695C149.098 38.8911 146.783 39.4518 144.214 39.4518ZM144.16 35.5989C145.752 35.5989 147.253 35.2552 148.664 34.5678C150.075 33.8443 151.215 32.7408 152.083 31.2576C152.987 29.7381 153.44 27.8207 153.44 25.5053C153.44 23.1537 153.006 21.2363 152.137 19.753C151.269 18.2697 150.129 17.1844 148.719 16.497C147.344 15.7735 145.86 15.4117 144.269 15.4117C142.677 15.4117 141.194 15.7735 139.819 16.497C138.444 17.1844 137.323 18.2878 136.454 19.8073C135.622 21.2906 135.206 23.1899 135.206 25.5053C135.206 27.8568 135.622 29.7743 136.454 31.2576C137.286 32.7408 138.372 33.8443 139.71 34.5678C141.085 35.2552 142.568 35.5989 144.16 35.5989Z" fill="#F5F4F3">
      </path>
      <path d="M104.416 3.05176e-05H108.486V15.6288C109.354 14.3264 110.53 13.3315 112.013 12.6441C113.497 11.9206 115.161 11.5588 117.006 11.5588C118.996 11.5588 120.768 12.011 122.324 12.9155C123.88 13.8199 125.092 15.1585 125.96 16.9312C126.864 18.7039 127.317 20.9108 127.317 23.5517V39.072H122.975V24.0401C122.975 21.2183 122.378 19.0657 121.184 17.5824C119.991 16.0629 118.254 15.3032 115.975 15.3032C113.623 15.3032 111.778 16.0991 110.44 17.6909C109.137 19.2828 108.486 21.5981 108.486 24.6371V39.072H104.416V3.05176e-05Z" fill="#F5F4F3">
      </path>
      <path d="M87.7398 19.753C89.7657 19.753 91.4118 19.4455 92.678 18.8304C93.9443 18.2154 94.8668 17.3472 95.4456 16.2256C96.0607 15.1041 96.3682 13.8017 96.3682 12.3185C96.3682 9.9669 95.6808 8.13993 94.306 6.83753C92.9675 5.53513 90.7787 4.88393 87.7398 4.88393H78.6773V19.753H87.7398ZM100.655 12.3185C100.655 13.8017 100.402 15.2308 99.8955 16.6055C99.4252 17.9441 98.6655 19.138 97.6163 20.1871C96.5672 21.2363 95.2286 22.0683 93.6006 22.6834C91.9726 23.2622 90.019 23.5516 87.7398 23.5516H78.6773V39.0719H74.3359V1.08527H87.7398C90.7064 1.08527 93.1303 1.59176 95.0115 2.60473C96.9289 3.61771 98.3399 4.97437 99.2443 6.67473C100.185 8.37508 100.655 10.2563 100.655 12.3185Z" fill="#F5F4F3">
      </path>
      <path d="M215.979 55.0819H219.723L219.94 59.0434C220.664 58.0666 221.532 57.2345 222.545 56.5471C223.594 55.8597 224.734 55.3894 225.964 55.1362C227.23 54.8467 228.568 54.8287 229.979 55.0819V59.1519C228.46 58.8625 227.085 58.8625 225.855 59.1519C224.661 59.4413 223.63 59.984 222.762 60.7799C221.894 61.5758 221.224 62.5888 220.754 63.8188C220.284 65.0127 220.049 66.4055 220.049 67.9974V82.2152H215.979V55.0819Z" fill="#F5F4F3">
      </path>
      <path d="M199.457 82.5951C196.925 82.5951 194.664 81.98 192.674 80.75C190.72 79.52 189.183 77.8377 188.061 75.7032C186.94 73.5687 186.379 71.1267 186.379 68.3772C186.379 65.7362 186.94 63.3847 188.061 61.3226C189.183 59.2604 190.72 57.6505 192.674 56.4928C194.627 55.299 196.852 54.702 199.349 54.702C201.809 54.702 203.997 55.2447 205.915 56.33C207.868 57.4154 209.388 58.9167 210.473 60.8342C211.559 62.7516 212.065 64.9403 211.993 67.4004C211.993 67.7984 211.975 68.2144 211.938 68.6485C211.902 69.0827 211.866 69.553 211.83 70.0595H190.829C190.901 71.7598 191.317 73.2612 192.077 74.5636C192.837 75.866 193.832 76.8971 195.062 77.6568C196.328 78.3804 197.757 78.7421 199.349 78.7421C201.447 78.7421 203.22 78.3442 204.667 77.5483C206.15 76.7524 207.217 75.6128 207.868 74.1295L211.396 75.5404C210.31 77.8196 208.737 79.5742 206.675 80.8043C204.612 81.9981 202.207 82.5951 199.457 82.5951ZM207.543 66.5321C207.579 64.9765 207.235 63.6018 206.512 62.4079C205.824 61.214 204.848 60.2734 203.581 59.586C202.315 58.8986 200.85 58.555 199.186 58.555C197.739 58.555 196.418 58.8986 195.224 59.586C194.03 60.2734 193.036 61.2321 192.24 62.4621C191.48 63.656 191.028 65.0127 190.883 66.5321H207.543Z" fill="#F5F4F3">
      </path>
      <path d="M162.686 43.1433H166.81V66.8578H169.306L179.997 55.0819H185.749L172.942 68.6486L185.803 82.2152H179.997L169.306 70.3851H166.81V82.2152H162.686V43.1433Z" fill="#F5F4F3">
      </path>
      <path d="M134.824 55.0819H138.569L138.786 58.9348C139.654 57.5962 140.794 56.5652 142.204 55.8416C143.615 55.0819 145.261 54.702 147.143 54.702C149.205 54.702 151.014 55.1542 152.569 56.0587C154.125 56.927 155.337 58.2474 156.205 60.0202C157.074 61.7567 157.508 63.9454 157.508 66.5864V82.2152H153.438V67.0748C153.438 64.2529 152.823 62.1185 151.593 60.6714C150.399 59.1881 148.662 58.4464 146.383 58.4464C144.031 58.4464 142.186 59.2242 140.848 60.7799C139.545 62.3355 138.894 64.6328 138.894 67.6717V82.2152H134.824V55.0819Z" fill="#F5F4F3">
      </path>
      <path d="M129.26 82.2151H125.57L125.299 78.3079C124.466 79.6827 123.345 80.7499 121.934 81.5097C120.523 82.2332 118.877 82.595 116.996 82.595C114.897 82.595 113.07 82.1608 111.515 81.2926C109.959 80.4243 108.747 79.1219 107.879 77.3854C107.047 75.6489 106.631 73.4601 106.631 70.8191V55.0818H110.647V70.385C110.647 73.1707 111.244 75.2871 112.437 76.7342C113.667 78.1451 115.422 78.8506 117.701 78.8506C120.017 78.8506 121.844 78.1089 123.182 76.6257C124.557 75.1062 125.244 72.827 125.244 69.7881V55.0818H129.26V82.2151Z" fill="#F5F4F3">
      </path>
      <path d="M97.3415 54.5392C97.3415 52.5494 96.6722 50.9757 95.3336 49.818C94.0312 48.6241 92.0776 48.0272 89.4728 48.0272H78.728V60.9969H89.6356C92.0957 60.9969 93.9951 60.4181 95.3336 59.2604C96.6722 58.1027 97.3415 56.5289 97.3415 54.5392ZM74.3867 82.2151V44.2285H89.8527C92.5299 44.2285 94.7367 44.6807 96.4732 45.5852C98.2098 46.4896 99.4941 47.6835 100.326 49.1668C101.194 50.6139 101.629 52.2238 101.629 53.9965C101.629 55.733 101.303 57.1982 100.652 58.3921C100.037 59.5498 99.1866 60.4723 98.1012 61.1597C97.0521 61.8471 95.8944 62.3174 94.6282 62.5706V62.9505C96.1476 63.1676 97.5043 63.656 98.6982 64.4157C99.892 65.1392 100.833 66.1341 101.52 67.4004C102.207 68.6666 102.551 70.2041 102.551 72.013C102.551 73.8943 102.081 75.6127 101.14 77.1683C100.2 78.724 98.8067 79.954 96.9616 80.8585C95.1527 81.7629 92.9278 82.2151 90.2868 82.2151H74.3867ZM78.728 78.4165H89.9612C92.566 78.4165 94.592 77.8376 96.0391 76.6799C97.5224 75.4861 98.264 73.7857 98.264 71.5789C98.264 69.372 97.4862 67.6898 95.9306 66.5321C94.4111 65.3744 92.3671 64.7956 89.7984 64.7956H78.728V78.4165Z" fill="#F5F4F3">
      </path>
      <path d="M22.3084 32.4163H4.48059L4.48142 56.6613L25.1063 70.5145L43.8151 56.713L43.8146 13.8578L24.1947 20.9256L9.69928 16.4769L9.67284 16.4686L9.64682 16.4599L0 13.1796L1.18458 9.69608L10.8058 12.9673L24.1014 17.0477L47.4944 8.62137L47.4948 58.5712L25.2062 75.0137L0.802112 58.6228L0.80046 28.7365H25.9881V53.7065H22.3084V32.4163Z" fill="#C4ED31">
      </path>
     </svg>
    </div>
    <ul className="nav">
     <li>
      <a className="btn btn-primary active" href="#main">
       <svg fill="none" height="27" viewbox="0 0 26 27" width="26">
        <path d="M21.7104 7.48301L15.4704 3.11718C13.7696 1.92551 11.1587 1.99051 9.52292 3.25801L4.09542 7.49385C3.01208 8.33885 2.15625 10.0722 2.15625 11.4372V18.9122C2.15625 21.6747 4.39875 23.928 7.16125 23.928H18.8396C21.6021 23.928 23.8446 21.6855 23.8446 18.923V11.578C23.8446 10.1155 22.9021 8.31718 21.7104 7.48301ZM13.8129 19.5947C13.8129 20.0388 13.4446 20.4072 13.0004 20.4072C12.5562 20.4072 12.1879 20.0388 12.1879 19.5947V16.3447C12.1879 15.9005 12.5562 15.5322 13.0004 15.5322C13.4446 15.5322 13.8129 15.9005 13.8129 16.3447V19.5947Z" fill="#F5F4F3">
        </path>
       </svg>
       Главная
      </a>
     </li>
     <li>
      <a className="btn btn-primary" href="#service">
       <svg fill="none" height="27" viewbox="0 0 26 27" width="26">
        <path d="M12.1883 4.32006V14.0917C12.1883 14.4492 12.015 14.7742 11.7225 14.9801L3.91163 20.4509C3.27247 20.8951 2.36247 20.5484 2.22163 19.7792C2.05913 18.8476 2.2758 17.7534 2.9258 16.5726L6.3058 10.4951L9.4908 4.76422C9.73997 4.32006 10.0108 3.93006 10.2925 3.59422C10.9425 2.83589 12.1883 3.32339 12.1883 4.32006Z" fill="#F5F4F3">
        </path>
        <path d="M22.0892 20.4509L14.2783 14.9801C13.9858 14.7742 13.8125 14.4492 13.8125 14.0917V4.32006C13.8125 3.32339 15.0583 2.83589 15.7083 3.59422C15.99 3.93006 16.2608 4.32006 16.51 4.76422L19.695 10.4951L23.075 16.5726C23.725 17.7534 23.9417 18.8476 23.7792 19.7792C23.6383 20.5484 22.7283 20.8951 22.0892 20.4509Z" fill="#F5F4F3">
        </path>
        <path d="M5.69869 20.83L12.3612 16.3883C12.7187 16.15 13.3037 16.15 13.6612 16.3883L20.3237 20.83C22.0895 22.0108 21.797 22.975 19.6737 22.975H6.33786C4.22536 22.9642 3.93286 22 5.69869 20.83Z" fill="#F5F4F3">
        </path>
       </svg>
       О сервисе
      </a>
     </li>
     <li>
      <a className="btn btn-primary" href="#ipfs">
       <svg fill="none" height="27" viewbox="0 0 26 27" width="26">
        <path d="M20.9411 6.24836L14.1486 2.58669C13.4336 2.19669 12.567 2.19669 11.852 2.58669L5.05948 6.24836C4.56115 6.51919 4.25781 7.03919 4.25781 7.63502C4.25781 8.22002 4.56115 8.75086 5.05948 9.02169L11.852 12.6834C12.2095 12.8784 12.6103 12.9759 13.0003 12.9759C13.3903 12.9759 13.7911 12.8784 14.1486 12.6834L20.9411 9.02169C21.4395 8.75086 21.7428 8.23086 21.7428 7.63502C21.7428 7.03919 21.4395 6.51919 20.9411 6.24836Z" fill="#F5F4F3">
        </path>
        <path d="M10.7352 13.9508L4.40852 10.7875C3.92102 10.5492 3.35768 10.5708 2.90268 10.8525C2.43685 11.145 2.16602 11.6325 2.16602 12.1742V18.1433C2.16602 19.1725 2.74018 20.1042 3.66102 20.57L9.97685 23.7333C10.1935 23.8417 10.4318 23.8958 10.6702 23.8958C10.9518 23.8958 11.2335 23.82 11.4827 23.6683C11.9485 23.3867 12.2193 22.8883 12.2193 22.3467V16.3775C12.2302 15.3375 11.656 14.4058 10.7352 13.9508Z" fill="#F5F4F3">
        </path>
        <path d="M23.096 10.8525C22.6301 10.5708 22.0668 10.5383 21.5901 10.7875L15.2743 13.9508C14.3535 14.4167 13.7793 15.3375 13.7793 16.3775V22.3467C13.7793 22.8883 14.0501 23.3867 14.516 23.6683C14.7651 23.82 15.0468 23.8958 15.3285 23.8958C15.5668 23.8958 15.8051 23.8417 16.0218 23.7333L22.3376 20.57C23.2585 20.1042 23.8326 19.1833 23.8326 18.1433V12.1742C23.8326 11.6325 23.5618 11.145 23.096 10.8525Z" fill="#F5F4F3">
        </path>
       </svg>
       Почему IPFS
      </a>
     </li>
    </ul>
    <svg className="bg-img" fill="none" height="203" viewbox="0 0 146 203" width="146">
     <g filter="url(#filter0_i_2010_3112)">
      <path d="M68.623 72.9775H14.3853L14.3878 146.739L77.1351 188.884L134.053 146.896L134.052 16.5169L74.3618 38.0195L30.2622 24.4848L30.1818 24.4597L30.1026 24.4333L0.753906 14.4536L4.35778 3.85556L33.6286 13.8077L74.0779 26.2214L145.247 0.585938L145.248 152.549L77.4392 202.572L3.19418 152.706L3.18916 61.7826H79.8179V137.749H68.623V72.9775Z" fill="#21252A">
      </path>
     </g>
     <defs>
      <filter color-interpolation-filters="sRGB" filterunits="userSpaceOnUse" height="204.893" id="filter0_i_2010_3112" width="144.494" x="0.753906" y="0.585938">
       <feflood flood-opacity="0" result="BackgroundImageFix">
       </feflood>
       <feblend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape">
       </feblend>
       <fecolormatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0">
       </fecolormatrix>
       <feoffset dy="5.8125">
       </feoffset>
       <fegaussianblur stddeviation="1.45313">
       </fegaussianblur>
       <fecomposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic">
       </fecomposite>
       <fecolormatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0">
       </fecolormatrix>
       <feblend in2="shape" mode="normal" result="effect1_innerShadow_2010_3112">
       </feblend>
      </filter>
     </defs>
    </svg>
    <a className="btn btn-primary active" href="#">
     <svg fill="none" height="27" viewbox="0 0 26 27" width="26">
      <path d="M18.416 2.72717H7.58268C4.33268 2.72717 2.16602 4.89384 2.16602 8.14384V14.6438C2.16602 17.8938 4.33268 20.0605 7.58268 20.0605V22.368C7.58268 23.2347 8.54685 23.7547 9.26185 23.2672L14.0827 20.0605H18.416C21.666 20.0605 23.8327 17.8938 23.8327 14.6438V8.14384C23.8327 4.89384 21.666 2.72717 18.416 2.72717ZM12.9993 15.9113C12.5443 15.9113 12.1868 15.543 12.1868 15.0988C12.1868 14.6547 12.5443 14.2863 12.9993 14.2863C13.4543 14.2863 13.8118 14.6547 13.8118 15.0988C13.8118 15.543 13.4543 15.9113 12.9993 15.9113ZM14.3643 11.4155C13.9418 11.6972 13.8118 11.8813 13.8118 12.1847V12.4122C13.8118 12.8563 13.4435 13.2247 12.9993 13.2247C12.5552 13.2247 12.1868 12.8563 12.1868 12.4122V12.1847C12.1868 10.928 13.1077 10.3105 13.4543 10.0722C13.8552 9.80134 13.9852 9.61717 13.9852 9.33551C13.9852 8.79384 13.541 8.34967 12.9993 8.34967C12.4577 8.34967 12.0135 8.79384 12.0135 9.33551C12.0135 9.77967 11.6452 10.148 11.201 10.148C10.7568 10.148 10.3885 9.77967 10.3885 9.33551C10.3885 7.89467 11.5585 6.72467 12.9993 6.72467C14.4402 6.72467 15.6102 7.89467 15.6102 9.33551C15.6102 10.5705 14.7002 11.188 14.3643 11.4155Z" fill="#2E323A">
      </path>
     </svg>
     Поддержка
    </a>
   </div>
  </aside>
  <div className="content">
   <div className="container">
    <div className="information">
     <p>
      Присоединяйтесь к нашему сервису и получайте доступ к безопасному и анонимному хранению изображений
     </p>
     <div className="social">
      <a className="btn btn-primary btn-icon active" href="#">
       <svg fill="none" height="26" viewbox="0 0 26 26" width="26">
        <path d="M18.416 3.79166H7.58268C4.33268 3.79166 2.16602 5.41666 2.16602 9.20832V16.7917C2.16602 20.5833 4.33268 22.2083 7.58268 22.2083H18.416C21.666 22.2083 23.8327 20.5833 23.8327 16.7917V9.20832C23.8327 5.41666 21.666 3.79166 18.416 3.79166ZM18.9252 10.3892L15.5343 13.0975C14.8193 13.6717 13.9093 13.9533 12.9993 13.9533C12.0893 13.9533 11.1685 13.6717 10.4643 13.0975L7.07352 10.3892C6.72685 10.1075 6.67268 9.58749 6.94352 9.24082C7.22518 8.89416 7.73435 8.82916 8.08102 9.11082L11.4718 11.8192C12.2952 12.48 13.6927 12.48 14.516 11.8192L17.9068 9.11082C18.2535 8.82916 18.7735 8.88332 19.0443 9.24082C19.326 9.58749 19.2718 10.1075 18.9252 10.3892Z" fill="#2E323A">
        </path>
       </svg>
       <span>
        E-mail
       </span>
      </a>
      <a className="btn btn-primary btn-icon active" href="#">
       <svg fill="none" height="26" viewbox="0 0 26 26" width="26">
        <path clip-rule="evenodd" d="M21.4265 4.79913C21.6942 4.68645 21.9872 4.64759 22.2751 4.68659C22.5629 4.72559 22.835 4.84102 23.0631 5.02087C23.2912 5.20072 23.4669 5.43842 23.5719 5.70922C23.6769 5.98002 23.7075 6.27402 23.6603 6.56063L21.2033 21.464C20.965 22.9016 19.3877 23.726 18.0692 23.01C16.9664 22.4109 15.3284 21.4879 13.8551 20.5248C13.1184 20.0427 10.8618 18.499 11.1392 17.4005C11.3775 16.4612 15.1692 12.9317 17.3358 10.8333C18.1862 10.0089 17.7984 9.5333 16.7942 10.2916C14.3003 12.1745 10.2963 15.0377 8.9725 15.8437C7.80467 16.5544 7.19583 16.6757 6.46783 16.5544C5.13966 16.3334 3.90791 15.991 2.90258 15.574C1.54408 15.0106 1.61016 13.143 2.9015 12.5991L21.4265 4.79913Z" fill="#2E323A" fill-rule="evenodd">
        </path>
       </svg>
       <span>
        Telegram
       </span>
      </a>
     </div>
    </div>
    <div className="files card">
     <div className="h1 --b-bottom --neon">
      Галерея
      <div className="btn-group">
       <button className="btn btn-tertiary">
        <svg fill="none" height="18" viewbox="0 0 18 18" width="18">
         <path d="M14.3034 10.6797C14.0859 10.8972 13.7409 10.8972 13.5309 10.6797C13.3134 10.4622 13.3134 10.1172 13.5309 9.90721C15.0309 8.40721 15.0309 5.96971 13.5309 4.47721C12.0309 2.98471 9.59344 2.97721 8.10094 4.47721C6.60844 5.97721 6.60094 8.41471 8.10094 9.90721C8.31844 10.1247 8.31844 10.4697 8.10094 10.6797C7.88344 10.8972 7.53844 10.8972 7.32844 10.6797C5.40094 8.75221 5.40094 5.61721 7.32844 3.69721C9.25594 1.77721 12.3909 1.76971 14.3109 3.69721C16.2309 5.62471 16.2309 8.75221 14.3034 10.6797Z" fill="#F5F4F3">
         </path>
         <path d="M3.69656 7.32035C3.91406 7.10285 4.25906 7.10285 4.46906 7.32035C4.68656 7.53785 4.68656 7.88285 4.46906 8.09285C2.96906 9.59285 2.96906 12.0304 4.46906 13.5229C5.96906 15.0154 8.40656 15.0229 9.89906 13.5229C11.3916 12.0229 11.3991 9.58535 9.89906 8.09285C9.68156 7.87535 9.68156 7.53035 9.89906 7.32035C10.1166 7.10285 10.4616 7.10285 10.6716 7.32035C12.5991 9.24785 12.5991 12.3829 10.6716 14.3029C8.74406 16.2229 5.60906 16.2304 3.68906 14.3029C1.76906 12.3754 1.76906 9.24785 3.69656 7.32035Z" fill="#F5F4F3">
         </path>
        </svg>
       </button>
       <button className="btn btn-tertiary" data-modal="modal-qr">
        <svg fill="none" height="18" viewbox="0 0 18 18" width="18">
         <path d="M12.375 16.125C12.375 16.5392 12.0392 16.875 11.625 16.875H10.875C10.4608 16.875 10.125 16.5392 10.125 16.125V15.375C10.125 14.9608 10.4608 14.625 10.875 14.625H12.375V16.125ZM16.875 16.125C16.875 16.5392 16.5392 16.875 16.125 16.875H15.375C14.9608 16.875 14.625 16.5392 14.625 16.125V14.625H16.125C16.5392 14.625 16.875 14.9608 16.875 15.375V16.125ZM14.625 14.625H12.375V12.375H14.625V14.625ZM12.375 12.375H10.875C10.4608 12.375 10.125 12.0392 10.125 11.625V10.875C10.125 10.4608 10.4608 10.125 10.875 10.125H11.625C12.0392 10.125 12.375 10.4608 12.375 10.875V12.375ZM16.875 11.625C16.875 12.0392 16.5392 12.375 16.125 12.375H14.625V10.875C14.625 10.4608 14.9608 10.125 15.375 10.125H16.125C16.5392 10.125 16.875 10.4608 16.875 10.875V11.625Z" fill="#F5F4F3">
         </path>
         <rect height="6.375" rx="0.9375" stroke="#F5F4F3" stroke-width="1.125" width="6.375" x="1.3125" y="1.3125">
         </rect>
         <rect height="6.375" rx="0.9375" stroke="#F5F4F3" stroke-width="1.125" width="6.375" x="10.3125" y="1.3125">
         </rect>
         <rect height="6.375" rx="0.9375" stroke="#F5F4F3" stroke-width="1.125" width="6.375" x="1.3125" y="10.3125">
         </rect>
        </svg>
       </button>
      </div>
     </div>
     <p>
{descrx}     </p>
     <div className="files-list">
        {imageUrls.map((url, index) => (
      <div className="files-item">
       <div className="file-name">
        <span>
         Image1longname.jpeg
        </span>
        <button className="btn remove">
         <svg fill="none" height="24" viewbox="0 0 24 24" width="24">
          <path d="M4 4L19.9999 19.9999" stroke="#F5F4F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          </path>
          <path d="M4.00013 19.9999L20 4" stroke="#F5F4F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          </path>
         </svg>
        </button>
       </div>
       <div
        className="file-img"
        data-img={url}
        data-modal="modal-gallery"
      >
        <img src={url} alt={`Preview ${index}`} />
      </div>
      </div>
          ))}
      
     
     </div>
    </div>
   </div>
  </div>
 </main>
                
 <footer>
  <div className="footer-top">
   <div className="logo">
    <svg fill="none" height="62" viewbox="0 0 172 62" width="172">
     <path d="M141.192 29.3367C139.282 29.3367 137.573 28.9197 136.067 28.0857C134.56 27.2518 133.377 26.0681 132.516 24.5347C131.655 22.9743 131.225 21.1315 131.225 19.0063C131.225 16.8541 131.655 14.9979 132.516 13.4376C133.404 11.8773 134.601 10.6801 136.107 9.84616C137.641 9.0122 139.362 8.59521 141.273 8.59521C143.183 8.59521 144.891 9.0122 146.397 9.84616C147.931 10.6801 149.128 11.8773 149.989 13.4376C150.877 14.971 151.32 16.8003 151.32 18.9256C151.32 21.0777 150.877 22.934 149.989 24.4943C149.101 26.0546 147.89 27.2518 146.357 28.0857C144.824 28.9197 143.102 29.3367 141.192 29.3367ZM141.151 26.4716C142.335 26.4716 143.452 26.216 144.501 25.7049C145.55 25.1669 146.397 24.3463 147.043 23.2434C147.716 22.1135 148.052 20.6877 148.052 18.9659C148.052 17.2173 147.729 15.7915 147.083 14.6885C146.438 13.5855 145.59 12.7785 144.541 12.2673C143.519 11.7293 142.416 11.4603 141.232 11.4603C140.048 11.4603 138.945 11.7293 137.923 12.2673C136.901 12.7785 136.067 13.599 135.421 14.7289C134.803 15.8319 134.493 17.2442 134.493 18.9659C134.493 20.7146 134.803 22.1404 135.421 23.2434C136.04 24.3463 136.847 25.1669 137.843 25.7049C138.865 26.216 139.968 26.4716 141.151 26.4716Z" fill="#F5F4F3">
     </path>
     <path d="M121.599 8.8777V3.22827H124.625V8.8777H129.992V11.7024H124.625V22.5574C124.625 23.7949 124.881 24.6961 125.392 25.261C125.93 25.826 126.603 26.1622 127.41 26.2698C128.244 26.3774 129.104 26.3774 129.992 26.2698V28.8928C128.943 29.1349 127.907 29.2022 126.885 29.0946C125.89 28.9869 124.988 28.691 124.181 28.2068C123.401 27.6956 122.769 26.9827 122.285 26.0681C121.827 25.1534 121.599 23.9832 121.599 22.5574V11.7024H118.572V8.8777H121.599Z" fill="#F5F4F3">
     </path>
     <path d="M107.239 29.3367C105.329 29.3367 103.62 28.9197 102.114 28.0857C100.607 27.2518 99.4236 26.0681 98.5628 24.5347C97.7019 22.9743 97.2715 21.1315 97.2715 19.0063C97.2715 16.8541 97.7019 14.9979 98.5628 13.4376C99.4505 11.8773 100.648 10.6801 102.154 9.84616C103.688 9.0122 105.409 8.59521 107.319 8.59521C109.229 8.59521 110.938 9.0122 112.444 9.84616C113.978 10.6801 115.175 11.8773 116.036 13.4376C116.923 14.971 117.367 16.8003 117.367 18.9256C117.367 21.0777 116.923 22.934 116.036 24.4943C115.148 26.0546 113.937 27.2518 112.404 28.0857C110.87 28.9197 109.149 29.3367 107.239 29.3367ZM107.198 26.4716C108.382 26.4716 109.498 26.216 110.548 25.7049C111.597 25.1669 112.444 24.3463 113.09 23.2434C113.762 22.1135 114.099 20.6877 114.099 18.9659C114.099 17.2173 113.776 15.7915 113.13 14.6885C112.485 13.5855 111.637 12.7785 110.588 12.2673C109.566 11.7293 108.463 11.4603 107.279 11.4603C106.095 11.4603 104.992 11.7293 103.97 12.2673C102.948 12.7785 102.114 13.599 101.468 14.7289C100.849 15.8319 100.54 17.2442 100.54 18.9659C100.54 20.7146 100.849 22.1404 101.468 23.2434C102.087 24.3463 102.894 25.1669 103.889 25.7049C104.912 26.216 106.015 26.4716 107.198 26.4716Z" fill="#F5F4F3">
     </path>
     <path d="M77.6445 0H80.671V11.6217C81.3167 10.6532 82.191 9.91339 83.294 9.40225C84.3969 8.86421 85.6344 8.59519 87.0064 8.59519C88.486 8.59519 89.8042 8.93147 90.961 9.60402C92.1178 10.2766 93.019 11.2719 93.6647 12.5901C94.3372 13.9083 94.6735 15.5494 94.6735 17.5132V29.0542H91.4453V17.8764C91.4453 15.778 91.0014 14.1774 90.1136 13.0744C89.2258 11.9445 87.9345 11.3795 86.2397 11.3795C84.4911 11.3795 83.1191 11.9714 82.1237 13.1551C81.1552 14.3388 80.671 16.0605 80.671 18.3203V29.0542H77.6445V0Z" fill="#F5F4F3">
     </path>
     <path d="M65.2445 14.6886C66.751 14.6886 67.9751 14.4599 68.9167 14.0026C69.8582 13.5452 70.5442 12.8996 70.9747 12.0656C71.432 11.2317 71.6607 10.2632 71.6607 9.1602C71.6607 7.41157 71.1495 6.05302 70.1273 5.08455C69.1319 4.11608 67.5043 3.63184 65.2445 3.63184H58.5056V14.6886H65.2445ZM74.8486 9.1602C74.8486 10.2632 74.6602 11.3258 74.2836 12.3481C73.9339 13.3435 73.3689 14.2312 72.5888 15.0114C71.8086 15.7915 70.8133 16.4103 69.6027 16.8676C68.3921 17.2981 66.9394 17.5133 65.2445 17.5133H58.5056V29.0542H55.2773V0.807129H65.2445C67.4505 0.807129 69.2529 1.18376 70.6518 1.93701C72.0776 2.69027 73.1268 3.69909 73.7994 4.96349C74.4988 6.22788 74.8486 7.62679 74.8486 9.1602Z" fill="#F5F4F3">
     </path>
     <path d="M160.604 40.959H163.388L163.549 43.9047C164.087 43.1784 164.733 42.5596 165.486 42.0485C166.266 41.5374 167.114 41.1876 168.028 40.9993C168.97 40.7841 169.965 40.7707 171.015 40.959V43.9854C169.885 43.7702 168.862 43.7702 167.948 43.9854C167.06 44.2007 166.293 44.6042 165.648 45.196C165.002 45.7879 164.504 46.5411 164.155 47.4558C163.805 48.3436 163.63 49.3793 163.63 50.563V61.1355H160.604V40.959Z" fill="#F5F4F3">
     </path>
     <path d="M148.319 61.4182C146.436 61.4182 144.754 60.9609 143.275 60.0462C141.822 59.1315 140.679 57.8806 139.845 56.2934C139.011 54.7062 138.594 52.8903 138.594 50.8457C138.594 48.8819 139.011 47.1332 139.845 45.5998C140.679 44.0664 141.822 42.8693 143.275 42.0084C144.727 41.1206 146.382 40.6768 148.238 40.6768C150.067 40.6768 151.695 41.0803 153.121 41.8873C154.574 42.6944 155.703 43.8108 156.51 45.2366C157.318 46.6625 157.694 48.29 157.64 50.1194C157.64 50.4153 157.627 50.7247 157.6 51.0475C157.573 51.3703 157.546 51.72 157.519 52.0967H141.903C141.957 53.3611 142.266 54.4775 142.831 55.446C143.396 56.4144 144.136 57.1811 145.05 57.7461C145.992 58.2841 147.054 58.5531 148.238 58.5531C149.798 58.5531 151.117 58.2572 152.193 57.6654C153.296 57.0735 154.089 56.2261 154.574 55.1231L157.196 56.1723C156.389 57.8671 155.219 59.1719 153.686 60.0866C152.152 60.9743 150.363 61.4182 148.319 61.4182ZM154.331 49.4737C154.358 48.3169 154.103 47.2947 153.565 46.4069C153.054 45.5191 152.327 44.8197 151.386 44.3085C150.444 43.7974 149.355 43.5418 148.117 43.5418C147.041 43.5418 146.059 43.7974 145.171 44.3085C144.284 44.8197 143.544 45.5326 142.952 46.4472C142.387 47.335 142.051 48.3438 141.943 49.4737H154.331Z" fill="#F5F4F3">
     </path>
     <path d="M120.975 32.0815H124.041V49.7158H125.898L133.847 40.9592H138.125L128.601 51.0475L138.165 61.1357H133.847L125.898 52.3388H124.041V61.1357H120.975V32.0815Z" fill="#F5F4F3">
     </path>
     <path d="M100.256 40.9592H103.04L103.202 43.8243C103.847 42.8289 104.695 42.0622 105.744 41.5242C106.793 40.9592 108.017 40.6768 109.416 40.6768C110.949 40.6768 112.295 41.013 113.451 41.6856C114.608 42.3312 115.509 43.3132 116.155 44.6314C116.801 45.9226 117.123 47.5502 117.123 49.5141V61.1357H114.097V49.8772C114.097 47.7789 113.64 46.1917 112.725 45.1156C111.837 44.0126 110.546 43.4611 108.851 43.4611C107.102 43.4611 105.73 44.0395 104.735 45.1963C103.767 46.3531 103.282 48.0614 103.282 50.3211V61.1357H100.256V40.9592Z" fill="#F5F4F3">
     </path>
     <path d="M96.1182 61.1355H93.3742L93.1725 58.2301C92.5537 59.2523 91.7197 60.046 90.6706 60.6109C89.6214 61.1489 88.3973 61.418 86.9984 61.418C85.4381 61.418 84.0796 61.0951 82.9228 60.4495C81.766 59.8038 80.8648 58.8354 80.2191 57.5441C79.6004 56.2528 79.291 54.6252 79.291 52.6614V40.959H82.2771V52.3385C82.2771 54.41 82.721 55.9838 83.6088 57.0598C84.5235 58.109 85.8282 58.6336 87.523 58.6336C89.2448 58.6336 90.6033 58.0821 91.5987 56.9791C92.621 55.8492 93.1321 54.1544 93.1321 51.8947V40.959H96.1182V61.1355Z" fill="#F5F4F3">
     </path>
     <path d="M72.3838 40.5555C72.3838 39.0759 71.8861 37.9057 70.8907 37.0448C69.9222 36.157 68.4695 35.7131 66.5326 35.7131H58.5427V45.3575H66.6537C68.483 45.3575 69.8953 44.9271 70.8907 44.0662C71.8861 43.2053 72.3838 42.0351 72.3838 40.5555ZM55.3145 61.1355V32.8884H66.8151C68.8058 32.8884 70.4468 33.2247 71.7381 33.8973C73.0294 34.5698 73.9844 35.4576 74.6032 36.5606C75.2488 37.6366 75.5717 38.8338 75.5717 40.152C75.5717 41.4433 75.3295 42.5328 74.8453 43.4206C74.388 44.2814 73.7558 44.9674 72.9487 45.4786C72.1686 45.9897 71.3077 46.3394 70.3661 46.5277V46.8102C71.496 46.9716 72.5048 47.3348 73.3926 47.8997C74.2804 48.4378 74.9798 49.1776 75.491 50.1192C76.0021 51.0607 76.2577 52.2041 76.2577 53.5492C76.2577 54.9481 75.9079 56.2259 75.2085 57.3827C74.509 58.5395 73.4733 59.4542 72.1013 60.1267C70.7562 60.7993 69.1017 61.1355 67.1379 61.1355H55.3145ZM58.5427 58.3108H66.8958C68.8327 58.3108 70.3392 57.8804 71.4153 57.0195C72.5183 56.1318 73.0698 54.8674 73.0698 53.2263C73.0698 51.5853 72.4914 50.3344 71.3346 49.4735C70.2047 48.6127 68.6848 48.1822 66.7747 48.1822H58.5427V58.3108Z" fill="#F5F4F3">
     </path>
     <path d="M16.5887 24.1049H3.3318L3.33241 42.1337L18.6692 52.435L32.5812 42.1721L32.5809 10.3047L17.9913 15.5604L7.21245 12.2523L7.19279 12.2461L7.17344 12.2397L0 9.80043L0.880863 7.21005L8.03526 9.64256L17.9219 12.6767L35.3171 6.41089L35.3174 43.5539L18.7435 55.7807L0.596456 43.5923L0.595227 21.3687H19.3249V39.9365H16.5887V24.1049Z" fill="#C4ED31">
     </path>
    </svg>
   </div>
   <div className="social">
    <a className="btn btn-primary btn-icon active" href="#">
     <svg fill="none" height="26" viewbox="0 0 26 26" width="26">
      <path d="M18.416 3.79166H7.58268C4.33268 3.79166 2.16602 5.41666 2.16602 9.20832V16.7917C2.16602 20.5833 4.33268 22.2083 7.58268 22.2083H18.416C21.666 22.2083 23.8327 20.5833 23.8327 16.7917V9.20832C23.8327 5.41666 21.666 3.79166 18.416 3.79166ZM18.9252 10.3892L15.5343 13.0975C14.8193 13.6717 13.9093 13.9533 12.9993 13.9533C12.0893 13.9533 11.1685 13.6717 10.4643 13.0975L7.07352 10.3892C6.72685 10.1075 6.67268 9.58749 6.94352 9.24082C7.22518 8.89416 7.73435 8.82916 8.08102 9.11082L11.4718 11.8192C12.2952 12.48 13.6927 12.48 14.516 11.8192L17.9068 9.11082C18.2535 8.82916 18.7735 8.88332 19.0443 9.24082C19.326 9.58749 19.2718 10.1075 18.9252 10.3892Z" fill="#2E323A">
      </path>
     </svg>
     <span>
      E-mail
     </span>
    </a>
    <a className="btn btn-primary btn-icon active" href="#">
     <svg fill="none" height="26" viewbox="0 0 26 26" width="26">
      <path clip-rule="evenodd" d="M21.4265 4.79913C21.6942 4.68645 21.9872 4.64759 22.2751 4.68659C22.5629 4.72559 22.835 4.84102 23.0631 5.02087C23.2912 5.20072 23.4669 5.43842 23.5719 5.70922C23.6769 5.98002 23.7075 6.27402 23.6603 6.56063L21.2033 21.464C20.965 22.9016 19.3877 23.726 18.0692 23.01C16.9664 22.4109 15.3284 21.4879 13.8551 20.5248C13.1184 20.0427 10.8618 18.499 11.1392 17.4005C11.3775 16.4612 15.1692 12.9317 17.3358 10.8333C18.1862 10.0089 17.7984 9.5333 16.7942 10.2916C14.3003 12.1745 10.2963 15.0377 8.9725 15.8437C7.80467 16.5544 7.19583 16.6757 6.46783 16.5544C5.13966 16.3334 3.90791 15.991 2.90258 15.574C1.54408 15.0106 1.61016 13.143 2.9015 12.5991L21.4265 4.79913Z" fill="#2E323A" fill-rule="evenodd">
      </path>
     </svg>
     <span>
      Telegram
     </span>
    </a>
   </div>
  </div>
  <div className="footer-bot">
   <span>
    Бесплатное хранилище нового поколения для ваших медиафайлов
   </span>
   <span>
    All rights reserved
   </span>
  </div>
 </footer>
 <div className="modal" id="modal-gallery">
  <div className="modal-content card">
   <div className="modal-head --b-bottom">
    <span>
     Image1.jpeg
    </span>
    <button className="btn close" data-modal-close="modal-gallery">
     <svg fill="none" height="24" viewbox="0 0 24 24" width="24">
      <path d="M4 4L19.9999 19.9999" stroke="#F5F4F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      </path>
      <path d="M4.00013 19.9999L20 4" stroke="#F5F4F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      </path>
     </svg>
    </button>
   </div>
   <div className="modal-body">
    <div className="modal-body-img">
     <img src="/assets/img/mocks/2.jpg" alt="Gallery image"/>
    </div>
    <div className="btn-prev">
     <svg fill="none" height="18" viewbox="0 0 18 18" width="18">
      <path clip-rule="evenodd" d="M11.6467 2.66231C11.8663 2.88198 11.8663 3.23814 11.6467 3.45781L6.75665 8.34781C6.39882 8.70564 6.39882 9.29448 6.75665 9.65231L11.6467 14.5423C11.8663 14.762 11.8663 15.1181 11.6467 15.3378C11.427 15.5575 11.0708 15.5575 10.8512 15.3378L5.96116 10.4478C5.16399 9.65064 5.16399 8.34948 5.96116 7.55231L10.8512 2.66231C11.0708 2.44264 11.427 2.44264 11.6467 2.66231Z" fill="#F5F4F3" fill-rule="evenodd">
      </path>
     </svg>
    </div>
    <div className="btn-next">
     <svg fill="none" height="18" viewbox="0 0 18 18" width="18">
      <path clip-rule="evenodd" d="M6.28585 2.66225C6.50552 2.44258 6.86167 2.44258 7.08134 2.66225L11.9713 7.55225C12.7685 8.34942 12.7685 9.65058 11.9713 10.4477L7.08134 15.3377C6.86167 15.5574 6.50552 15.5574 6.28585 15.3377C6.06618 15.1181 6.06618 14.7619 6.28585 14.5423L11.1758 9.65225C11.5337 9.29442 11.5337 8.70558 11.1758 8.34775L6.28585 3.45775C6.06618 3.23808 6.06618 2.88192 6.28585 2.66225Z" fill="#F5F4F3" fill-rule="evenodd">
      </path>
     </svg>
    </div>
   </div>
  </div>
 </div>
 <div className="modal" id="modal-qr">
  <div className="modal-content card">
   <div className="modal-head --b-bottom">
    Скачать QR-код
    <button className="btn close" data-modal-close="modal-qr">
     <svg fill="none" height="24" viewbox="0 0 24 24" width="24">
      <path d="M4 4L19.9999 19.9999" stroke="#F5F4F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      </path>
      <path d="M4.00013 19.9999L20 4" stroke="#F5F4F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      </path>
     </svg>
    </button>
   </div>
   <div className="modal-body">
    <div className="modal-qr">
     <svg fill="none" height="300" viewbox="0 0 301 300" width="301">
      <g clip-path="url(#clip0_2029_4288)">
       <path d="M96.5 0V12H108.5V0L102.5 3.375L96.5 0Z" fill="#C4ED31">
       </path>
       <path d="M132.5 0V12H144.5V0L138.5 3.375L132.5 0Z" fill="#C4ED31">
       </path>
       <path d="M168.5 0H156.5V12H168.5V0Z" fill="#C4ED31">
       </path>
       <path d="M180.5 0H168.5V12H180.5L177.125 6L180.5 0Z" fill="#C4ED31">
       </path>
       <path d="M108.5 12H96.5V24H108.5V12Z" fill="#C4ED31">
       </path>
       <path d="M120.5 12H108.5V24H120.5V12Z" fill="#C4ED31">
       </path>
       <path d="M144.5 24V12H132.5V24L138.5 20.625L144.5 24Z" fill="#C4ED31">
       </path>
       <path d="M168.5 12H156.5V24H168.5V12Z" fill="#C4ED31">
       </path>
       <path d="M192.5 12V24H204.5V12L198.5 15.375L192.5 12Z" fill="#C4ED31">
       </path>
       <path d="M108.5 24H96.5V36H108.5V24Z" fill="#C4ED31">
       </path>
       <path d="M120.5 24H108.5V36H120.5V24Z" fill="#C4ED31">
       </path>
       <path d="M144.5 36H156.5V24H144.5L147.875 30L144.5 36Z" fill="#C4ED31">
       </path>
       <path d="M168.5 24H156.5V36H168.5V24Z" fill="#C4ED31">
       </path>
       <path d="M180.5 24H168.5V36H180.5L177.125 30L180.5 24Z" fill="#C4ED31">
       </path>
       <path d="M204.5 24H192.5V36H204.5V24Z" fill="#C4ED31">
       </path>
       <path d="M120.5 36H108.5V48H120.5V36Z" fill="#C4ED31">
       </path>
       <path d="M132.5 36H120.5V48H132.5V36Z" fill="#C4ED31">
       </path>
       <path d="M144.5 36H132.5V48H144.5L141.125 42L144.5 36Z" fill="#C4ED31">
       </path>
       <path d="M168.5 48V36H156.5V48L162.5 44.625L168.5 48Z" fill="#C4ED31">
       </path>
       <path d="M180.5 48H192.5V36H180.5L183.875 42L180.5 48Z" fill="#C4ED31">
       </path>
       <path d="M204.5 36H192.5V48H204.5V36Z" fill="#C4ED31">
       </path>
       <path d="M96.5 60H108.5V48H96.5L99.875 54L96.5 60Z" fill="#C4ED31">
       </path>
       <path d="M120.5 48H108.5V60H120.5V48Z" fill="#C4ED31">
       </path>
       <path d="M204.5 48H192.5V60H204.5V48Z" fill="#C4ED31">
       </path>
       <path d="M120.5 72V60H108.5V72L114.5 68.625L120.5 72Z" fill="#C4ED31">
       </path>
       <path d="M156.5 60H144.5V72H156.5V60Z" fill="#C4ED31">
       </path>
       <path d="M168.5 60H156.5V72H168.5L165.125 66L168.5 60Z" fill="#C4ED31">
       </path>
       <path d="M204.5 60H192.5V72H204.5V60Z" fill="#C4ED31">
       </path>
       <path d="M108.5 72H96.5V84H108.5V72Z" fill="#C4ED31">
       </path>
       <path d="M120.5 72V84H132.5V72L126.5 75.375L120.5 72Z" fill="#C4ED31">
       </path>
       <path d="M156.5 84V72H144.5V84L150.5 80.625L156.5 84Z" fill="#C4ED31">
       </path>
       <path d="M168.5 72V84H180.5V72L174.5 75.375L168.5 72Z" fill="#C4ED31">
       </path>
       <path d="M204.5 72H192.5V84H204.5V72Z" fill="#C4ED31">
       </path>
       <path d="M132.5 96V84H120.5V96L126.5 92.625L132.5 96Z" fill="#C4ED31">
       </path>
       <path d="M156.5 96H168.5V84H156.5L159.875 90L156.5 96Z" fill="#C4ED31">
       </path>
       <path d="M180.5 84H168.5V96H180.5V84Z" fill="#C4ED31">
       </path>
       <path d="M192.5 84H180.5V96H192.5V84Z" fill="#C4ED31">
       </path>
       <path d="M204.5 84H192.5V96H204.5V84Z" fill="#C4ED31">
       </path>
       <path d="M12.5 96H0.5V108H12.5V96Z" fill="#C4ED31">
       </path>
       <path d="M48.5 96H36.5V108H48.5V96Z" fill="#C4ED31">
       </path>
       <path d="M60.5 96H48.5V108H60.5V96Z" fill="#C4ED31">
       </path>
       <path d="M72.5 96H60.5V108H72.5V96Z" fill="#C4ED31">
       </path>
       <path d="M84.5 96H72.5V108H84.5V96Z" fill="#C4ED31">
       </path>
       <path d="M96.5 96H84.5V108H96.5V96Z" fill="#C4ED31">
       </path>
       <path d="M108.5 96H96.5V108H108.5V96Z" fill="#C4ED31">
       </path>
       <path d="M120.5 96H108.5V108H120.5L117.125 102L120.5 96Z" fill="#C4ED31">
       </path>
       <path d="M204.5 96H192.5V108H204.5V96Z" fill="#C4ED31">
       </path>
       <path d="M216.5 96H204.5V108H216.5L213.125 102L216.5 96Z" fill="#C4ED31">
       </path>
       <path d="M240.5 96V108H252.5V96L246.5 99.375L240.5 96Z" fill="#C4ED31">
       </path>
       <path d="M276.5 96H264.5V108H276.5V96Z" fill="#C4ED31">
       </path>
       <path d="M288.5 96H276.5V108H288.5V96Z" fill="#C4ED31">
       </path>
       <path d="M300.5 96H288.5V108H300.5L297.125 102L300.5 96Z" fill="#C4ED31">
       </path>
       <path d="M48.5 120V108H36.5V120L42.5 116.625L48.5 120Z" fill="#C4ED31">
       </path>
       <path d="M120.5 120H132.5V108H120.5L123.875 114L120.5 120Z" fill="#C4ED31">
       </path>
       <path d="M144.5 108H132.5V120H144.5V108Z" fill="#C4ED31">
       </path>
       <path d="M156.5 108H144.5V120H156.5V108Z" fill="#C4ED31">
       </path>
       <path d="M168.5 108H156.5V120H168.5V108Z" fill="#C4ED31">
       </path>
       <path d="M180.5 108H168.5V120H180.5V108Z" fill="#C4ED31">
       </path>
       <path d="M192.5 108H180.5V120H192.5V108Z" fill="#C4ED31">
       </path>
       <path d="M228.5 120H240.5V108H228.5L231.875 114L228.5 120Z" fill="#C4ED31">
       </path>
       <path d="M252.5 108H240.5V120H252.5V108Z" fill="#C4ED31">
       </path>
       <path d="M264.5 108H252.5V120H264.5V108Z" fill="#C4ED31">
       </path>
       <path d="M276.5 108H264.5V120H276.5V108Z" fill="#C4ED31">
       </path>
       <path d="M288.5 108H276.5V120H288.5V108Z" fill="#C4ED31">
       </path>
       <path d="M12.5 132H24.5V120H12.5L15.875 126L12.5 132Z" fill="#C4ED31">
       </path>
       <path d="M36.5 120H24.5V132H36.5L33.125 126L36.5 120Z" fill="#C4ED31">
       </path>
       <path d="M84.5 120H72.5V132H84.5V120Z" fill="#C4ED31">
       </path>
       <path d="M108.5 120H96.5V132H108.5V120Z" fill="#C4ED31">
       </path>
       <path d="M156.5 120H144.5V132H156.5V120Z" fill="#C4ED31">
       </path>
       <path d="M168.5 120H156.5V132H168.5V120Z" fill="#C4ED31">
       </path>
       <path d="M192.5 120H180.5V132H192.5V120Z" fill="#C4ED31">
       </path>
       <path d="M204.5 120H192.5V132H204.5V120Z" fill="#C4ED31">
       </path>
       <path d="M216.5 120H204.5V132H216.5V120Z" fill="#C4ED31">
       </path>
       <path d="M252.5 120H240.5V132H252.5V120Z" fill="#C4ED31">
       </path>
       <path d="M264.5 120H252.5V132H264.5V120Z" fill="#C4ED31">
       </path>
       <path d="M288.5 120V132H300.5V120L294.5 123.375L288.5 120Z" fill="#C4ED31">
       </path>
       <path d="M12.5 132H0.5V144H12.5V132Z" fill="#C4ED31">
       </path>
       <path d="M36.5 144H48.5V132H36.5L39.875 138L36.5 144Z" fill="#C4ED31">
       </path>
       <path d="M60.5 132H48.5V144H60.5V132Z" fill="#C4ED31">
       </path>
       <path d="M72.5 132H60.5V144H72.5L69.125 138L72.5 132Z" fill="#C4ED31">
       </path>
       <path d="M120.5 132H108.5V144H120.5V132Z" fill="#C4ED31">
       </path>
       <path d="M132.5 144H144.5V132H132.5L135.875 138L132.5 144Z" fill="#C4ED31">
       </path>
       <path d="M156.5 132H144.5V144H156.5V132Z" fill="#C4ED31">
       </path>
       <path d="M216.5 132H204.5V144H216.5V132Z" fill="#C4ED31">
       </path>
       <path d="M228.5 132H216.5V144H228.5V132Z" fill="#C4ED31">
       </path>
       <path d="M264.5 132H252.5V144H264.5V132Z" fill="#C4ED31">
       </path>
       <path d="M276.5 132H264.5V144H276.5V132Z" fill="#C4ED31">
       </path>
       <path d="M288.5 132H276.5V144H288.5V132Z" fill="#C4ED31">
       </path>
       <path d="M300.5 132H288.5V144H300.5V132Z" fill="#C4ED31">
       </path>
       <path d="M24.5 144H12.5V156H24.5V144Z" fill="#C4ED31">
       </path>
       <path d="M36.5 144H24.5V156H36.5L33.125 150L36.5 144Z" fill="#C4ED31">
       </path>
       <path d="M60.5 156V144H48.5V156L54.5 152.625L60.5 156Z" fill="#C4ED31">
       </path>
       <path d="M84.5 144H72.5V156H84.5V144Z" fill="#C4ED31">
       </path>
       <path d="M120.5 144V156H132.5V144L126.5 147.375L120.5 144Z" fill="#C4ED31">
       </path>
       <path d="M180.5 144V156H192.5V144L186.5 147.375L180.5 144Z" fill="#C4ED31">
       </path>
       <path d="M228.5 156V144H216.5V156L222.5 152.625L228.5 156Z" fill="#C4ED31">
       </path>
       <path d="M300.5 156V144H288.5V156L294.5 152.625L300.5 156Z" fill="#C4ED31">
       </path>
       <path d="M12.5 156H0.5V168H12.5V156Z" fill="#C4ED31">
       </path>
       <path d="M24.5 156H12.5V168H24.5V156Z" fill="#C4ED31">
       </path>
       <path d="M96.5 156H84.5V168H96.5V156Z" fill="#C4ED31">
       </path>
       <path d="M120.5 156H108.5V168H120.5V156Z" fill="#C4ED31">
       </path>
       <path d="M132.5 156H120.5V168H132.5V156Z" fill="#C4ED31">
       </path>
       <path d="M144.5 168H156.5V156H144.5L147.875 162L144.5 168Z" fill="#C4ED31">
       </path>
       <path d="M168.5 156H156.5V168H168.5V156Z" fill="#C4ED31">
       </path>
       <path d="M192.5 156H180.5V168H192.5V156Z" fill="#C4ED31">
       </path>
       <path d="M204.5 156H192.5V168H204.5V156Z" fill="#C4ED31">
       </path>
       <path d="M240.5 156V168H252.5V156L246.5 159.375L240.5 156Z" fill="#C4ED31">
       </path>
       <path d="M276.5 156V168H288.5V156L282.5 159.375L276.5 156Z" fill="#C4ED31">
       </path>
       <path d="M12.5 168H0.5V180H12.5V168Z" fill="#C4ED31">
       </path>
       <path d="M24.5 168H12.5V180H24.5V168Z" fill="#C4ED31">
       </path>
       <path d="M36.5 180H48.5V168H36.5L39.875 174L36.5 180Z" fill="#C4ED31">
       </path>
       <path d="M60.5 168H48.5V180H60.5V168Z" fill="#C4ED31">
       </path>
       <path d="M72.5 168H60.5V180H72.5V168Z" fill="#C4ED31">
       </path>
       <path d="M84.5 168H72.5V180H84.5L81.125 174L84.5 168Z" fill="#C4ED31">
       </path>
       <path d="M96.5 180H108.5V168H96.5L99.875 174L96.5 180Z" fill="#C4ED31">
       </path>
       <path d="M120.5 168H108.5V180H120.5V168Z" fill="#C4ED31">
       </path>
       <path d="M168.5 180V168H156.5V180L162.5 176.625L168.5 180Z" fill="#C4ED31">
       </path>
       <path d="M192.5 168H180.5V180H192.5V168Z" fill="#C4ED31">
       </path>
       <path d="M204.5 168H192.5V180H204.5V168Z" fill="#C4ED31">
       </path>
       <path d="M216.5 168H204.5V180H216.5V168Z" fill="#C4ED31">
       </path>
       <path d="M252.5 168H240.5V180H252.5V168Z" fill="#C4ED31">
       </path>
       <path d="M264.5 168H252.5V180H264.5V168Z" fill="#C4ED31">
       </path>
       <path d="M276.5 168H264.5V180H276.5V168Z" fill="#C4ED31">
       </path>
       <path d="M288.5 168H276.5V180H288.5V168Z" fill="#C4ED31">
       </path>
       <path d="M300.5 168H288.5V180H300.5V168Z" fill="#C4ED31">
       </path>
       <path d="M12.5 180H0.5V192H12.5V180Z" fill="#C4ED31">
       </path>
       <path d="M72.5 180H60.5V192H72.5V180Z" fill="#C4ED31">
       </path>
       <path d="M120.5 192V180H108.5V192L114.5 188.625L120.5 192Z" fill="#C4ED31">
       </path>
       <path d="M144.5 180V192H156.5V180L150.5 183.375L144.5 180Z" fill="#C4ED31">
       </path>
       <path d="M168.5 192H180.5V180H168.5L171.875 186L168.5 192Z" fill="#C4ED31">
       </path>
       <path d="M192.5 180H180.5V192H192.5V180Z" fill="#C4ED31">
       </path>
       <path d="M204.5 180H192.5V192H204.5V180Z" fill="#C4ED31">
       </path>
       <path d="M216.5 180H204.5V192H216.5V180Z" fill="#C4ED31">
       </path>
       <path d="M228.5 180V192H240.5V180L234.5 183.375L228.5 180Z" fill="#C4ED31">
       </path>
       <path d="M264.5 180H252.5V192H264.5V180Z" fill="#C4ED31">
       </path>
       <path d="M276.5 180H264.5V192H276.5V180Z" fill="#C4ED31">
       </path>
       <path d="M300.5 192V180H288.5V192L294.5 188.625L300.5 192Z" fill="#C4ED31">
       </path>
       <path d="M12.5 204V192H0.5V204L6.5 200.625L12.5 204Z" fill="#C4ED31">
       </path>
       <path d="M48.5 204H60.5V192H48.5L51.875 198L48.5 204Z" fill="#C4ED31">
       </path>
       <path d="M72.5 192H60.5V204H72.5V192Z" fill="#C4ED31">
       </path>
       <path d="M84.5 192H72.5V204H84.5V192Z" fill="#C4ED31">
       </path>
       <path d="M96.5 192H84.5V204H96.5V192Z" fill="#C4ED31">
       </path>
       <path d="M108.5 192H96.5V204H108.5V192Z" fill="#C4ED31">
       </path>
       <path d="M144.5 192H132.5V204H144.5V192Z" fill="#C4ED31">
       </path>
       <path d="M156.5 192H144.5V204H156.5V192Z" fill="#C4ED31">
       </path>
       <path d="M168.5 192H156.5V204H168.5L165.125 198L168.5 192Z" fill="#C4ED31">
       </path>
       <path d="M192.5 192H180.5V204H192.5V192Z" fill="#C4ED31">
       </path>
       <path d="M204.5 192H192.5V204H204.5V192Z" fill="#C4ED31">
       </path>
       <path d="M216.5 192H204.5V204H216.5V192Z" fill="#C4ED31">
       </path>
       <path d="M228.5 192H216.5V204H228.5V192Z" fill="#C4ED31">
       </path>
       <path d="M240.5 192H228.5V204H240.5V192Z" fill="#C4ED31">
       </path>
       <path d="M252.5 192H240.5V204H252.5V192Z" fill="#C4ED31">
       </path>
       <path d="M276.5 192H264.5V204H276.5V192Z" fill="#C4ED31">
       </path>
       <path d="M288.5 192H276.5V204H288.5V192Z" fill="#C4ED31">
       </path>
       <path d="M108.5 204H96.5V216H108.5V204Z" fill="#C4ED31">
       </path>
       <path d="M120.5 204H108.5V216H120.5V204Z" fill="#C4ED31">
       </path>
       <path d="M132.5 204H120.5V216H132.5V204Z" fill="#C4ED31">
       </path>
       <path d="M144.5 204H132.5V216H144.5V204Z" fill="#C4ED31">
       </path>
       <path d="M168.5 204V216H180.5V204L174.5 207.375L168.5 204Z" fill="#C4ED31">
       </path>
       <path d="M204.5 204H192.5V216H204.5V204Z" fill="#C4ED31">
       </path>
       <path d="M252.5 204H240.5V216H252.5V204Z" fill="#C4ED31">
       </path>
       <path d="M276.5 204H264.5V216H276.5V204Z" fill="#C4ED31">
       </path>
       <path d="M288.5 204H276.5V216H288.5V204Z" fill="#C4ED31">
       </path>
       <path d="M108.5 216H96.5V228H108.5V216Z" fill="#C4ED31">
       </path>
       <path d="M120.5 216H108.5V228H120.5V216Z" fill="#C4ED31">
       </path>
       <path d="M156.5 216H144.5V228H156.5V216Z" fill="#C4ED31">
       </path>
       <path d="M180.5 216H168.5V228H180.5V216Z" fill="#C4ED31">
       </path>
       <path d="M204.5 216H192.5V228H204.5V216Z" fill="#C4ED31">
       </path>
       <path d="M228.5 216H216.5V228H228.5V216Z" fill="#C4ED31">
       </path>
       <path d="M252.5 216H240.5V228H252.5V216Z" fill="#C4ED31">
       </path>
       <path d="M288.5 216V228H300.5V216L294.5 219.375L288.5 216Z" fill="#C4ED31">
       </path>
       <path d="M108.5 228H96.5V240H108.5V228Z" fill="#C4ED31">
       </path>
       <path d="M132.5 228V240H144.5V228L138.5 231.375L132.5 228Z" fill="#C4ED31">
       </path>
       <path d="M156.5 240H168.5V228H156.5L159.875 234L156.5 240Z" fill="#C4ED31">
       </path>
       <path d="M180.5 228H168.5V240H180.5V228Z" fill="#C4ED31">
       </path>
       <path d="M192.5 228H180.5V240H192.5V228Z" fill="#C4ED31">
       </path>
       <path d="M204.5 228H192.5V240H204.5V228Z" fill="#C4ED31">
       </path>
       <path d="M252.5 228H240.5V240H252.5V228Z" fill="#C4ED31">
       </path>
       <path d="M300.5 240V228H288.5V240L294.5 236.625L300.5 240Z" fill="#C4ED31">
       </path>
       <path d="M108.5 240H96.5V252H108.5V240Z" fill="#C4ED31">
       </path>
       <path d="M120.5 240H108.5V252H120.5L117.125 246L120.5 240Z" fill="#C4ED31">
       </path>
       <path d="M144.5 240H132.5V252H144.5V240Z" fill="#C4ED31">
       </path>
       <path d="M156.5 240H144.5V252H156.5V240Z" fill="#C4ED31">
       </path>
       <path d="M180.5 240H168.5V252H180.5V240Z" fill="#C4ED31">
       </path>
       <path d="M192.5 240H180.5V252H192.5V240Z" fill="#C4ED31">
       </path>
       <path d="M204.5 240H192.5V252H204.5V240Z" fill="#C4ED31">
       </path>
       <path d="M216.5 240H204.5V252H216.5V240Z" fill="#C4ED31">
       </path>
       <path d="M228.5 240H216.5V252H228.5V240Z" fill="#C4ED31">
       </path>
       <path d="M240.5 240H228.5V252H240.5V240Z" fill="#C4ED31">
       </path>
       <path d="M252.5 240H240.5V252H252.5V240Z" fill="#C4ED31">
       </path>
       <path d="M108.5 264V252H96.5V264L102.5 260.625L108.5 264Z" fill="#C4ED31">
       </path>
       <path d="M132.5 252H120.5V264H132.5V252Z" fill="#C4ED31">
       </path>
       <path d="M156.5 252H144.5V264H156.5V252Z" fill="#C4ED31">
       </path>
       <path d="M168.5 252H156.5V264H168.5V252Z" fill="#C4ED31">
       </path>
       <path d="M180.5 252H168.5V264H180.5V252Z" fill="#C4ED31">
       </path>
       <path d="M192.5 252H180.5V264H192.5V252Z" fill="#C4ED31">
       </path>
       <path d="M216.5 252H204.5V264H216.5V252Z" fill="#C4ED31">
       </path>
       <path d="M228.5 252H216.5V264H228.5V252Z" fill="#C4ED31">
       </path>
       <path d="M288.5 252H276.5V264H288.5V252Z" fill="#C4ED31">
       </path>
       <path d="M300.5 252H288.5V264H300.5V252Z" fill="#C4ED31">
       </path>
       <path d="M120.5 264H108.5V276H120.5V264Z" fill="#C4ED31">
       </path>
       <path d="M144.5 264H132.5V276H144.5V264Z" fill="#C4ED31">
       </path>
       <path d="M168.5 276V264H156.5V276L162.5 272.625L168.5 276Z" fill="#C4ED31">
       </path>
       <path d="M204.5 264H192.5V276H204.5V264Z" fill="#C4ED31">
       </path>
       <path d="M252.5 264H240.5V276H252.5V264Z" fill="#C4ED31">
       </path>
       <path d="M264.5 264H252.5V276H264.5V264Z" fill="#C4ED31">
       </path>
       <path d="M276.5 264H264.5V276H276.5V264Z" fill="#C4ED31">
       </path>
       <path d="M288.5 264H276.5V276H288.5V264Z" fill="#C4ED31">
       </path>
       <path d="M300.5 264H288.5V276H300.5V264Z" fill="#C4ED31">
       </path>
       <path d="M168.5 276V288H180.5V276L174.5 279.375L168.5 276Z" fill="#C4ED31">
       </path>
       <path d="M228.5 276H216.5V288H228.5V276Z" fill="#C4ED31">
       </path>
       <path d="M240.5 276H228.5V288H240.5V276Z" fill="#C4ED31">
       </path>
       <path d="M252.5 276H240.5V288H252.5V276Z" fill="#C4ED31">
       </path>
       <path d="M276.5 276H264.5V288H276.5V276Z" fill="#C4ED31">
       </path>
       <path d="M288.5 276H276.5V288H288.5V276Z" fill="#C4ED31">
       </path>
       <path d="M300.5 276H288.5V288H300.5V276Z" fill="#C4ED31">
       </path>
       <path d="M108.5 288H96.5V300H108.5V288Z" fill="#C4ED31">
       </path>
       <path d="M132.5 288H120.5V300H132.5V288Z" fill="#C4ED31">
       </path>
       <path d="M156.5 288H144.5V300H156.5V288Z" fill="#C4ED31">
       </path>
       <path d="M180.5 300V288H168.5V300L174.5 296.625L180.5 300Z" fill="#C4ED31">
       </path>
       <path d="M192.5 300H204.5V288H192.5L195.875 294L192.5 300Z" fill="#C4ED31">
       </path>
       <path d="M216.5 288H204.5V300H216.5V288Z" fill="#C4ED31">
       </path>
       <path d="M228.5 288H216.5V300H228.5V288Z" fill="#C4ED31">
       </path>
       <path d="M264.5 288H252.5V300H264.5V288Z" fill="#C4ED31">
       </path>
       <path d="M300.5 300V288H288.5V300L294.5 296.625L300.5 300Z" fill="#C4ED31">
       </path>
       <path d="M0.5 55.6256V28.35C0.5 12.7184 13.3688 0 29.1784 0H55.8224C71.6312 0 84.5 12.7184 84.5 28.35V84L29.1784 83.9832C13.3688 83.9832 0.5 71.2656 0.5 55.6256ZM13.1 55.6256C13.1 64.3146 20.3122 71.384 29.1818 71.384L71.9 71.3966V28.35C71.9 19.6652 64.6878 12.6 55.8224 12.6H29.1784C20.3122 12.6 13.1 19.6652 13.1 28.35V55.6256Z" fill="#C4ED31">
       </path>
       <path d="M300.5 55.6256V28.35C300.5 12.7184 287.631 0 271.822 0H245.178C229.369 0 216.5 12.7184 216.5 28.35V84L271.822 83.9832C287.631 83.9832 300.5 71.2656 300.5 55.6256ZM287.9 55.6256C287.9 64.3146 280.688 71.384 271.818 71.384L229.1 71.3966V28.35C229.1 19.6652 236.312 12.6 245.178 12.6H271.822C280.688 12.6 287.9 19.6652 287.9 28.35V55.6256Z" fill="#C4ED31">
       </path>
       <path d="M0.5 244.374V271.65C0.5 287.282 13.3688 300 29.1784 300H55.8224C71.6312 300 84.5 287.282 84.5 271.65V216L29.1784 216.017C13.3688 216.017 0.5 228.734 0.5 244.374ZM13.1 244.374C13.1 235.685 20.3122 228.616 29.1818 228.616L71.9 228.603V271.65C71.9 280.335 64.6878 287.4 55.8224 287.4H29.1784C20.3122 287.4 13.1 280.335 13.1 271.65V244.374Z" fill="#C4ED31">
       </path>
       <path d="M24.5 50.2004V33.7902C24.5 28.3931 28.9626 24 34.4468 24H50.5532C56.0371 24 60.5 28.3931 60.5 33.7902V60L34.4468 59.9849C28.9626 59.9849 24.5 55.5976 24.5 50.2004Z" fill="#C4ED31">
       </path>
       <path d="M276.5 50.2004V33.7902C276.5 28.3931 272.037 24 266.553 24H250.447C244.963 24 240.5 28.3931 240.5 33.7902V60L266.553 59.9849C272.037 59.9849 276.5 55.5976 276.5 50.2004Z" fill="#C4ED31">
       </path>
       <path d="M24.5 249.8V266.21C24.5 271.607 28.9626 276 34.4468 276H50.5532C56.0371 276 60.5 271.607 60.5 266.21V240L34.4468 240.015C28.9626 240.015 24.5 244.402 24.5 249.8Z" fill="#C4ED31">
       </path>
      </g>
      <defs>
       <clippath id="clip0_2029_4288">
        <rect fill="white" height="300" transform="translate(0.5)" width="300">
        </rect>
       </clippath>
      </defs>
     </svg>
    </div>
    <div className="btn-group">
     <button className="btn btn-secondary">
      PNG
     </button>
     <button className="btn btn-secondary">
      SVG
     </button>
     <button className="btn btn-secondary">
      EPSS
     </button>
     <button className="btn btn-secondary">
      PDF
     </button>
    </div>
   </div>
  </div>
 </div>
       </div>
);;
};

export default GalleryPage;
